/* eslint-disable react/style-prop-object */
import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import ViewTeamMember from "./ViewTeamMember/ViewTeamMember";
import { useGetSpecificMemberQuery, useGetAllTeamsQuery } from "../../../Redux/service/Teams/Teams";
import { ConfigProvider, Tag } from "antd";
import Button from "../../Helpers/Button/Button";
import { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";

export function TeamMemberPopup({ memberId, onClose }) {
  const { data, isFetching } = useGetSpecificMemberQuery(memberId, {
    skip: !memberId,
    refetchOnMountOrArgChange: true,
  });
  
  // // Fetch all teams to get teams assigned to this member
  // const { data: teamsData } = useGetAllTeamsQuery(
  //   {
  //     page: 1,
  //     limit: 10000,
  //     search: "",
  //   },
  //   {
  //     refetchOnMountOrArgChange: false,
  //   }
  // );

  const { handleShow } = useContext(popupcontext);

  const { edit: canEdit } = usePermission("SNAG");
  const member = data?.data || "";

  const statusColors = {
    ACTIVE: `green`,
    INACTIVE: `red`,
  };

  // Get teams assigned to this member
  // const getAssignedTeams = () => {
  //   if (!teamsData?.data || !member?.id) return [];
  //   return teamsData.data.filter((team) =>
  //     team.memberUserIds?.includes(member.id)
  //   );
  // };

  // const assignedTeams = getAssignedTeams();

  const onEdit = () => {
    onClose();
    handleShow("editForm", "member", memberId);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0f6936",
          activeBg: "#0f6936",
          activeBorderColor: "#2e9245",
        },
      }}
    >
      <Popup show={!!memberId} size={"xl"}>
        <Modal.Header className="modal-header flex-between">
          <Modal.Title id="contained-modal-title-vcenter">
            <PopupTitle
              headtitle={
                <div>
                  {member.name || "Loading..."}{" "}
                  {!isFetching && member.status && (
                    <Tag
                      color={
                        statusColors[member.status] || statusColors.INACTIVE
                      }
                      className="text-capitalize"
                    >
                      {trans(member.status)}
                    </Tag>
                  )}
                </div>
              }
              subtitle={`${member.email || ""}`}
            />
          </Modal.Title>
          <Close style="close-32 close" close={onClose} img="Close" />
        </Modal.Header>
        <Modal.Body className="modal-body-scrollable fixed-popup-height">
          {isFetching ? (
            <div className="loader-container">
              <Loader />
            </div>
          ) : (
            <ViewTeamMember data={member} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="popups-footer gap-8">
            {canEdit && (
              <Button
                type="primary"
                text={trans("Edit Member")}
                htmlType="submit"
                onClick={() => onEdit()}
              />
            )}
          </div>
        </Modal.Footer>
      </Popup>
    </ConfigProvider>
  );
}
